import { Box, Skeleton, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { ImageAppHistoryItem, ImageSuiteApps, SuiteApps } from "../../../../Helper";
import { DownloadImage } from "../../../../shared/DownloadImage";
import { RemoveIcon } from "../../../../Custom-imeges/RemoveIcon";
import {
  convertUtcToLocalDate,
  formatDateAndHour,
} from "../../../../store/one-query/useMethodHelper";
import { DeleteAllHistoryModal } from "../../../../Layouts/SuiteHistoryLayout/Shared/DeleteAllHistoryModal";
import { returnAppIcon } from "../../../../Layouts/SuiteHistoryLayout/View/SuiteHistoryView";
import TrashIcon from "../../../../Custom-imeges/TrashIcon";
import { InputAndOutputTypes } from "../../../../Types/ImageSuite-types";
import { GenerateImgIcon } from "../../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateImgIcon";
import { VideoDetailsView } from "../../../VideoSuite/Components/Shared/VideoSuiteHelper";

interface ImageAppHistoryItemProps {
  imageAppItem: ImageAppHistoryItem;
  DeleteImageItem: (itemId: string) => void;
  handleCloseDisplayItemModal: (show: boolean) => void;
  handleActiveHistoryItem: (item?: ImageAppHistoryItem) => void;
  isDeleteImageItemLoading: boolean;
  isImageItemDeleted: boolean;
  showImageOptions?: { download: boolean, delete: boolean, share: boolean }
  cardView: number,
}

const styles = {
  cursor: "pointer",
  backgroundColor: "rgba(255, 255, 255, 0.51)",
  opacity: 1,
  zIndex: 100,
  padding: "3px !important",
  transition: "opacity 0.3s ease",
  borderRadius: "3px",
  "&:hover": {
    backgroundColor: "#FFF",
  },
};
export const ImageSuiteHistoryItem = ({
  imageAppItem,
  DeleteImageItem,
  handleCloseDisplayItemModal,
  handleActiveHistoryItem,
  isDeleteImageItemLoading,
  isImageItemDeleted,
  showImageOptions = { download: true, delete: true, share: false },
  cardView
}: ImageAppHistoryItemProps) => {
  const [canShowDeleteAllHistory, setCanShowDeleteAllHistory] = useState(false);
  const [historyItemId, setHistoryItemId] = useState("");
  const [imageLoading, setImageLoading] = useState(true);
  const [imageHover, setImageHover] = useState(false);
  const handleShowDeleteItemModal = (itemId: string) => {
    setHistoryItemId(itemId);
    setCanShowDeleteAllHistory(true);
    handleCloseDisplayItemModal(false);
  };

  const handleDeleteImageItem = () => {
    DeleteImageItem(historyItemId);
  };

  useEffect(() => {
    if (isImageItemDeleted) {
      setCanShowDeleteAllHistory(false);
    }
  }, [isImageItemDeleted]);
  return (
    <Box
      className={`video-card ${
        imageHover && !imageLoading
          ? "video-card-hover"
          : "video-card-not-hover"
      }`}
      sx={{
        cursor: imageLoading?"not-allowed":"pointer",
      }}
      onMouseEnter={() => setImageHover(true)}
      onMouseLeave={() => setImageHover(false)}
    >
      <Box className="image-suite-history-item">
        {imageLoading && cardView !== VideoDetailsView.library ? (
          <Skeleton
            className="skeleton-background"
            variant="rectangular"
            width="100%"
            height="100%"
            animation="wave"
          />
        ) : null}
        <img
          loading="lazy"
          className="item-image"
          src={
            (imageAppItem.outputType & InputAndOutputTypes.Image) ===
            InputAndOutputTypes.Image
              ? imageAppItem.output
              : imageAppItem?.input?.imageUrl
          }
          alt=""
          style={{
            width: "100%",
            height: "100%",
            display:"block",
          }}
          onLoad={() => setImageLoading(false)}
          onError={() => setImageLoading(false)}
        />
        {!imageLoading && imageHover && (
          <Box className="video-hover-overlay">
            <Box className={`image-item-actions ${!showImageOptions.delete && "display-bottom"}`}>
              {
                showImageOptions.download && 
                <Box>
                  <DownloadImage style={styles} imgURL={imageAppItem.output} />
              </Box>
              }
              {
                showImageOptions.delete &&
                <Box
                sx={{ ...styles, padding: "3px 8px !important" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleShowDeleteItemModal(imageAppItem.id);
                }}
              >
                <TrashIcon className="trash-icon" />
              </Box>
              }
            </Box>
            <Box
              className="image-item-details"
              onClick={() => handleActiveHistoryItem(imageAppItem)}
            >
              {(imageAppItem.outputType & InputAndOutputTypes.Text) ===
                InputAndOutputTypes.Text && (
                <Box className="app-text-output">
                  <Typography className="app-text-output-title">
                    Output
                  </Typography>
                  <Typography className="app-text-output-value">
                    {imageAppItem.output}
                  </Typography>
                </Box>
              )}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "8px",
                }}
              >
                <Box className="suite-app-name">
                  <Box className="app-name-icn">
                    {imageAppItem.appType===ImageSuiteApps.TextToImage?<GenerateImgIcon className="text-nav-item-icon" />: returnAppIcon(imageAppItem.appType)}
                  </Box>
                  <Box className="app-name-title" sx={{color:"#fff"}}>{imageAppItem.appType}</Box>
                </Box>
                {showImageOptions.delete &&
                  <Box className="suite-app-date">
                    {convertUtcToLocalDate(imageAppItem.createdAt)}
                  </Box>
                }
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      {canShowDeleteAllHistory && (
        <DeleteAllHistoryModal
          canShow={canShowDeleteAllHistory}
          handleClose={() => setCanShowDeleteAllHistory(false)}
          handleDeleteAllHistory={handleDeleteImageItem}
          isDeleteLoading={isDeleteImageItemLoading}
          message="Are you sure to clear this history item?"
        />
      )}
    </Box>
  );
};
